var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-tab1-inner",class:{ 'my-tab1-inner-checked': _vm.$route.path == _vm.path },on:{"click":_vm.toPath}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }